<template>
    <div>
    <main role="main" style = "padding-top:0px" class="right_wrapper">
      <div>
		  <!-- <div class="form-row header-style bread-crumb-small" style = "margin:0px; margin-bottom:30px" >
			  <a href="javascript:void(0) col-sm-3" @click="getBackToAccount('cancel')" class="form-group" style="line-height:1;margin:0px">Account Management ></a>
			  <span class="form-group col-sm-6" style="line-height:1;margin:0px; padding-left:10px">{{client_name}}</span>
			  <a href="javascript:void(0)" class="form-group col-sm-3 text-right"  v-if = "currentPage == 'detail'" @click = "navigateToEdit" style = "margin:0px">Edit</a>
		  </div> -->
		  <BreadCrumbHeader
          @backCalled="getBackToAccount('cancel')"
          :selectedName="client_name"
		  tabCalled='Tagging Strategy'
		  selectedModule='Tagging Strategy'
        />
		  <!-- <DetailTabs/> -->
		  <div v-if = "showData" class="table_wrap">
			  <div v-if = "currentPage == 'detail'">
				  <Detail :clientId = "clientId" :profileId = "profileId"/>
			  </div>
			  <!-- <div v-else>
				  <Tables
					:vendorId = "vendorId"
					:profile_brand_name = "brand_name"
				/>
			  </div> -->
		  </div>

      </div>
    </main>
    <!-- Modal Starts -->
    </div>
</template>

<script>

import DetailTabs from '@/components/tagging-strategy/DetailTabs.vue'
import Detail from '@/components/tagging-strategy/Detail.vue'
import Tables from '@/components/account-management/Tables.vue'
import BreadCrumbHeader from "@/components/BreadCrumbHeader.vue";

export default {
	name:'TaggingDetails',
	data(){
		return{
			brand_name:"",
			vendorId:"",
			profileId:"",
			profileData:{},
			showData:false,
			clientId:'',
			profile_route_id:'',
			client_name:''
		}
	},
	components:{
		DetailTabs,
		Detail,
		Tables,
		BreadCrumbHeader
	},
	computed:{
		currentPage:{
			set(val) {
				this.$store.state.accounts.accountTab =  val;
			},
			get() {
				return this.$store.state.accounts.accountTab;
			}
		}
	},
	mounted(){
		this.currentPage = 'detail'
		 this.profile_route_id = this.$route.params.profile_id
		 this.brand_name = this.$route.params.ProfileBrandName
		 this.vendorId = this.$route.params.vendorId;
		 this.client_name = atob(this.$route.params.clientName)
		// this.profileId = this.$route.params.ProfileId;
		if(this.$route.name == '/accountDetails/profile'){
			this.profileId = this.$route.params.profileId;
		}
		else{
			this.clientId = this.$route.params.clientId;
		}
		this.showData = true;
	},
	methods:{
		getBackToAccount(data){
			if (data == "cancel") {
				  this.$store.state.calledFromCancel = true;
			}
			this.$router.push({ path: "/taggingStrategy"});
		},
		navigateToEdit(){
			// if(this.clientId){
			// 	this.$router.push({
			// 		path: "/addVendor" + "/" + this.clientId + '/' + this.profile_route_id
			// 	});
			// }
			// else if(this.profileId){
			// 	this.$router.push({
			// 		path: "/editBrand" + "/" + this.profile_route_id + '/' + this.profile_route_id
			// 	});
			// }
			this.$router.push({
				path: "/addVendor" + "/" + this.clientId
			});
		}
	}
}
</script>

<style lang="scss">

</style>
